import { render, staticRenderFns } from "./ExpandableText.vue?vue&type=template&id=1e1ea130&scoped=true"
import script from "./ExpandableText.vue?vue&type=script&lang=js"
export * from "./ExpandableText.vue?vue&type=script&lang=js"
import style0 from "./ExpandableText.vue?vue&type=style&index=0&id=1e1ea130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1ea130",
  null
  
)

export default component.exports